import { FlexRow } from '@editor/components/utilities/layouts';
import { H4, P2 } from '@repo/ui/components/Typography';
import { ProfileImage } from '@repo/ui/deprecated/ProfileImage';

import { CheckoutFlowTestimonialWrapper } from './styles';

interface TestimonialProps {
  image: string;
  name: string;
  text: string;
}

const Testimonial: React.FC<TestimonialProps> = ({ image, name, text }) => {
  return (
    <CheckoutFlowTestimonialWrapper>
      <H4>
        <span>“</span>
        {text}
        <span>”</span>
      </H4>
      <FlexRow alignItems="center" gap="16px">
        <ProfileImage profile={{ profileImage: image }} size="44px" />
        <P2>{name}</P2>
      </FlexRow>
    </CheckoutFlowTestimonialWrapper>
  );
};

export default Testimonial;
